import * as types from './mutation-types'

const mutations = {
    [types.SET_ORDER_INFO](state, value) {
        state.orderInfo = value
    },
    [types.SET_PARKINGLOTID](state, value) {
        state.parkinglotId = value
    },
    [types.SET_OPENID](state, value) {
        state.openId = value
    },
    [types.SET_BUYID](state, value) {
        state.buyId = value
    },
    [types.SET_DOORID](state, value) {
        state.doorId = value
    },
    [types.SET_CURRENT_PATH](state, value) {
        state.currentPath = value
    },
    [types.SET_PARKREC](state, value) {
        state.parkrec = value
    },
    [types.SET_PARKING_INFO](state, value) {
        state.parkingInfo = value
    },
    [types.SET_COUPONFEE](state, value) {
        state.couponFee = value
    },
    [types.SET_LAST_PLATENO](state, value) {
        state.lastPlateno = value
    },
    [types.SET_AREA_ID](state, value) {
        state.areaId = value
    },
    [types.SET_CHECKED_PARKINGLOT_ID](state, value) {
        state.checkedParkingLotId = value
    },
    [types.SET_USER_PHONE](state, value) {
        state.userPhone = value
    },
    [types.SET_USER_OPENID](state, value) {
        state.userOpenid = value
    },
    [types.SET_BUSINESS_IDS](state, value) {
        state.businessIds = value
    },
    [types.SET_TASK_ID](state, value) {
        state.taskId = value
    },
    [types.SET_ORDERSN](state, value) {
        state.orderSn = value
    },
    [types.SET_RESULT_ORDERSN](state, value) {
        console.log(value,'5454456456');
        state.resultOrderSn = value
    },
    [types.SET_RECEIPT_ORDERSN_OBJ](state, value) {
        state.receiptOrderSnObj = value
    },
    [types.SET_RECEIPT_PARKINGLOTID](state, value) {
        state.receiptParkinglotId = value
    },
    [types.SET_TOTAL_PRICE](state, value) {
        state.totalPrice = value
    },
    [types.SET_ISNOTIFICATION](state, value) {
        state.isNotification = value
    },
    [types.SET_KEYTOPORDERNO](state, value) {
        state.keyTopOrderNo = value
    },
    [types.SET_PARKRECID](state, value) {
        state.parkRecId = value
    },


    [types.SET_CLICKMERRECORD](state, value) {
        state.clickMerRecord = value
    },
    [types.SET_INTERFACEMANNER](state, value) {
        state.interfaceManner = value
    },
    [types.SET_KEYTOPINIMGURL](state, value) {
        state.keyTopInImgUrl = value
    },

    [types.SET_ISCARDPAY](state, value) {
        state.isCardPay = value
    },

    [types.SET_RECEPITINFO](state, value) {
        state.receiptInfo = value
    },
    [types.SET_ORDERSNLIST](state, value) {
        state.orderSnList = value
    },
    [types.SET_ABPARKID](state, value) {
        state.abParkId = value
    },
    [types.SET_ABSHOW](state, value) {
        state.abShow = value
    },
    [types.SET_OPENAD](state, value) {
        state.isOpenAdvertising = value
    },

}

export default mutations
